import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';

export type InformationRowItem = {
  id?: string;
  label: ReactNode;
  value?: ReactNode;
  description?: ReactNode;
  trailing?: ReactNode;
};

export type InformationRowProps = InformationRowItem & {
  layout?: 'inline' | 'stacked';
  emphasizeValue?: boolean;
  emptyValue?: ReactNode;
  testId?: string;
  wide?: boolean;
};

/** dl 안에서 사용하는 읽기 전용 정보행입니다. 모바일에서는 label과 값을 순서대로 배치합니다. */
export function InformationRow({ label, value, description, trailing, layout = 'inline', emphasizeValue = false, emptyValue, testId, wide = false }: InformationRowProps) {
  const hasValue = value !== undefined && value !== null && value !== '';
  return <Box component="div" data-testid={testId} data-pattern="information-row" sx={{
    display: 'grid', minWidth: 0, gridColumn: wide ? { sm: '1 / -1' } : undefined,
    minHeight: layout === 'inline' ? designTokens.layout.informationRowMinHeight : undefined,
    gridTemplateColumns: layout === 'inline' ? { xs: 'minmax(0, 1fr)', sm: `minmax(0, ${designTokens.layout.informationRowLabelWidth}px) minmax(0, 1fr)` } : 'minmax(0, 1fr)',
    alignItems: 'start', columnGap: `${designTokens.layout.informationRowGap}px`, rowGap: `${designTokens.layout.listRowContentGap}px`,
  }}>
    <Typography component="dt" sx={{ ...designTokens.typography.ui, m: 0, minWidth: 0, fontWeight: 500, color: designTokens.color.secondaryText, overflowWrap: 'anywhere' }}>{label}</Typography>
    <Box component="dd" sx={{ m: 0, minWidth: 0 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: `${designTokens.layout.listRowContentGap}px`, minWidth: 0 }}>
        <Typography component="div" sx={{
          ...designTokens.typography.ui, minWidth: 0, maxWidth: '100%', fontWeight: emphasizeValue ? 600 : 400,
          color: hasValue ? designTokens.color.primaryText : designTokens.color.secondaryText, overflowWrap: 'anywhere',
        }}>{hasValue ? value : emptyValue}</Typography>
        {trailing ? <Box data-slot="trailing" sx={{ display: 'flex', minWidth: 0, maxWidth: '100%', flexWrap: 'wrap', gap: `${designTokens.layout.listRowContentGap}px` }}>{trailing}</Box> : null}
      </Box>
      {description ? <Typography component="div" sx={{ ...designTokens.typography.supporting, mt: `${designTokens.layout.listRowContentGap}px`, color: designTokens.color.secondaryText, overflowWrap: 'anywhere' }}>{description}</Typography> : null}
    </Box>
  </Box>;
}
